import React, { useContext, useEffect, useState} from "react";
import { Badge, BottomNavigation, BottomNavigationAction, useMediaQuery } from "@material-ui/core";
import {
  InfoOutlined,
  AssignmentTurnedInOutlined,
  ChatBubbleOutlineOutlined,
  DataUsageOutlined,
  ReportProblem
} from "@material-ui/icons";
import { StandardContainer, StretchRow } from "components/Layout/StandardStyledComponents";
import { BuildingContext, Incident } from "Context/BuildingProvider";
import { useStyles } from "Theme/styles";
interface MobileNavigationProps {
  setButtonValue(value: number): any;
}
interface NavState{
  noIncidents: number| null
}

const DEFAULT_STATE : NavState = {
  noIncidents: null
}
export default function MobileNavigation({
  setButtonValue,
}: MobileNavigationProps) {
  const [value, setValue] = useState(0);
  const [state, setState] = useState(DEFAULT_STATE)
  const { incidentState } = useContext(BuildingContext);
  const isDesktop = useMediaQuery("(min-width:600px)");
  const classes = useStyles();
  console.log("🚀 ~ file: MobileNavigation.tsx ~ line 21 ~ incidentState", incidentState)
  useEffect(() => {
    let noIncidents = 0
    for (const key in incidentState?.incidents) {
      noIncidents ++
    }
   
    if(noIncidents !== 0){

      setState({ ...state, noIncidents })
    }else{
      setState({...state, noIncidents: null})
    }
  }, [incidentState]);
  return (
      
      <BottomNavigation
      className={isDesktop ? classes.bottomNavDesktop :classes.bottomNavMobile}
        value={value}
        onChange={(event, newValue) => {
          setButtonValue(newValue);
          setValue(newValue);
        }}
        showLabels
      >
        
        <BottomNavigationAction label="Info Window" icon={<InfoOutlined />} />
        <BottomNavigationAction
          label="Chat"
          icon={<ChatBubbleOutlineOutlined />}
        />
        <BottomNavigationAction
          label="Send Tasks"
          icon={<AssignmentTurnedInOutlined />}
        />
        <BottomNavigationAction
          label="Data Usage"
          icon={<DataUsageOutlined />}
        />
        
        <BottomNavigationAction
          label="Incidents"
          icon={<Badge badgeContent={state.noIncidents} color="error"><ReportProblem /> </Badge>}
        />
       
      </BottomNavigation>
  );
}
